<style lang="scss" scoped>
.module3 {
  .slide-2 {
    background-image: url(../../../assets/module3/slide2/background-01.jpg);
    background-size: cover;
    background-position: center;
    padding-top: 100px;
    /* padding-left: 100px; */

    .pages {
      /* padding-left: 0; */
    }

    .page-left {
      flex-basis: 60%;
    }
    .page-right {
      flex-basis: 40%;
    }

    .heading {
      padding-left: 100px;
    }

    .precopy {
      color: #fff;
    }

    h1 {
      color: #fff;
      font-size: 70px;
      transform-origin: 30% 0;
    }

    .red {
      color: #e30613;
    }

    .heading4,
    .heading5 {
      color: #98c0d7;
      margin-left: 0;
      margin-top: 80px;
      font-size: 50px;
    }

    .number {
      font-size: 80px;
    }

    .heading5 {
      margin-left: 40px;
      margin-top: 0;
    }
  }
}
</style>

<template>
  <div class="slide-2">
    <transition name="scale" appear>
      <div class="heading" v-show="slideIndex == 1">
        <p class="precopy">{{ $t("module3.slide2.precopy") }}</p>
        <h1 class="heading1">
          {{ $t("module3.slide2.heading1") }}
          <span class="red">{{ $t("module3.slide2.heading2") }} </span>
        </h1>
        <h1 class="heading3">{{ $t("module3.slide2.heading3") }}</h1>
      </div>
    </transition>
    <div class="pages">
      <div class="page page-left">
        <transition name="fadeLeft" appear>
          <div>
            <h2 class="heading4">
              {{ $t("module3.slide2.heading4") }}
              <span class="red number">{{ $t("module3.slide2.number") }} </span>
            </h2>
            <h2 class="heading5">{{ $t("module3.slide2.heading5") }}</h2>
          </div>
        </transition>
      </div>

      <div class="page page-right">
        <transition name="fadeRight" appear>
          <div>
            <p
              class=" copy delay-3"
              v-show="slideIndex == 1"
              v-html="$t('module3.slide2.copy1')"
            ></p>
            <p
              class=" copy delay-3"
              v-show="slideIndex == 1"
              v-html="$t('module3.slide2.copy2')"
            ></p>
            <p
              class=" copy delay-3"
              v-show="slideIndex == 1"
              v-html="$t('module3.slide2.copy3')"
            ></p>
          </div>
        </transition>
      </div>
    </div>
    <transition name="fadeLeft" appear>
      <img
        v-show="slideIndex == 1"
        src="@/assets/module3/slide2/images-01.png"
        class="chars delay-6"
      />
    </transition>
  </div>
</template>

<script>
export default {
  props: ["slideIndex"]
};
</script>
